import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import AuthShell from "./AuthShell";
import { Field, Input } from "@/components/Field";

export default function Forgot() {
  const { t, lang } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/auth/forgot-password", { email }); setSent(true); toast.success("OK"); }
    catch (err) { toast.error(apiErr(err)); }
  };
  return (
    <AuthShell title={t("auth.forgot")} subtitle={lang === "de" ? "Wir senden Ihnen einen Link zum Zurücksetzen." : "We'll send you a reset link."}>
      {sent ? (
        <p className="surface p-4 text-sm text-muted-foreground" data-testid="forgot-sent">{lang === "de" ? "Falls ein Konto existiert, wurde eine E-Mail gesendet. (Reset-Token im Server-Log)" : "If an account exists, an email was sent. (Reset token in server log)"}</p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label={t("common.email")}><Input testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          <button className="btn-primary w-full" data-testid="forgot-submit">{t("common.send")}</button>
        </form>
      )}
      <p className="text-sm text-muted-foreground mt-6 text-center"><Link to="/login" className="text-primary font-semibold">{t("nav.login")}</Link></p>
    </AuthShell>
  );
}
